import { render, staticRenderFns } from "./RsQuestionSingleScale.vue?vue&type=template&id=06c4c0ae"
import script from "./RsQuestionSingleScale.vue?vue&type=script&lang=js"
export * from "./RsQuestionSingleScale.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports